import { ChangeDetectorRef, Directive, ElementRef, HostListener, inject, input, Input, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';

@Directive({
  selector: '[appMobTxtExpander]',
  standalone: true,
})
export class MobTxtExpanderDirective {
  get isMobileOrTablet(): boolean {
    return this._deviceDetectorService.isMobile() || this._deviceDetectorService.isTablet();
  }

  public text = input.required<string>();
  public onlyMobile = input<boolean>(false);

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly _renderer: Renderer2,
    private readonly _toastService: ToastrService,
    private readonly _deviceDetectorService: DeviceDetectorService,
    private readonly _cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this._renderer.setStyle(this._elementRef.nativeElement, 'transition', 'all 0.5s');
    if (!this.onlyMobile() || (this.onlyMobile() && this.isMobileOrTablet)) {
      this._collapseText();
    } else {
      this._renderer.setProperty(
        this._elementRef.nativeElement,
        'innerHTML',
        `${this.text().replace('cutPlace', '')} `,
      );
    }
  }

  private _collapseText(): void {
    this._renderer.setProperty(
      this._elementRef.nativeElement,
      'innerHTML',
      `${this.text().substring(0, this.text()?.indexOf('cutPlace'))} `,
    );

    let a = document.createElement('a');
    a.innerHTML = `Rozwiń >`;
    a.style.cursor = 'pointer';
    a.style.color = '#000';
    a.style.display = 'inline-block';
    a.style.fontWeight = '600';
    a.addEventListener('click', (event) => {
      this._expandText();
    });
    this._renderer.appendChild(this._elementRef.nativeElement, a);
  }

  private _expandText(): void {
    this._renderer.setProperty(this._elementRef.nativeElement, 'innerHTML', `${this.text().replace('cutPlace', '')} `);
    let a = document.createElement('a');
    a.innerHTML = `<  Zwiń`;
    a.style.cursor = 'pointer';
    a.style.color = '#000';
    a.style.display = 'inline-block';
    a.style.fontWeight = '600';

    a.addEventListener('click', (event) => {
      this._collapseText();
    });

    this._renderer.appendChild(this._elementRef.nativeElement, a);
  }
}
